"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Directions = exports.FormTypes = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var dayjs_1 = __importDefault(require("dayjs"));
var config_1 = __importDefault(require("config"));
var api_1 = __importStar(require("api"));
var use_nav_state_1 = require("hooks/use-nav-state");
var use_stores_1 = require("hooks/use-stores");
var NavState_1 = require("../../contexts/NavState");
var use_notification_1 = require("hooks/use-notification");
var use_dialog_1 = require("hooks/use-dialog");
var Notification_1 = require("../Notification");
var GanttChartHeader_1 = __importDefault(require("./gantt-chart-header/GanttChartHeader"));
var GanttChartGrid_1 = __importDefault(require("./GanttChartGrid"));
var GanttChartProject_1 = __importDefault(require("./gantt-chart-project/GanttChartProject"));
var GanttChartProjectForm_1 = __importDefault(require("./gantt-chart-project/GanttChartProjectForm"));
var utils_1 = require("../../util/utils");
var add_icon_dark_svg_1 = __importDefault(require("res/img/add-icon-dark.svg"));
var Dialog_1 = require("../Dialog");
var FormTypes;
(function (FormTypes) {
    FormTypes[FormTypes["ADD_FORM"] = 0] = "ADD_FORM";
    FormTypes[FormTypes["EDIT_FORM"] = 1] = "EDIT_FORM";
})(FormTypes = exports.FormTypes || (exports.FormTypes = {}));
var Directions;
(function (Directions) {
    Directions["FORWARDS"] = "forwards";
    Directions["BACKWARDS"] = "backwards";
})(Directions = exports.Directions || (exports.Directions = {}));
var apiRoutes = config_1.default.apiRoutes;
var GanttChart = mobx_react_1.observer(function () {
    var _a = react_1.useState(dayjs_1.default().startOf('d')), currentDate = _a[0], setCurrentDate = _a[1];
    var _b = react_1.useState(null), moving = _b[0], setMoving = _b[1];
    var _c = react_1.useState(null), mouseDown = _c[0], setMouseDown = _c[1];
    var _d = react_1.useState(null), addOpen = _d[0], setAddOpen = _d[1];
    var _e = react_1.useState(null), editOpen = _e[0], setEditOpen = _e[1];
    var _f = react_1.useState({}), projectData = _f[0], setProjectData = _f[1];
    var _g = react_1.useState(0), scrolledPast = _g[0], setScrolledPast = _g[1];
    var _h = react_1.useState(true), scrolling = _h[0], setScrolling = _h[1];
    var _j = use_stores_1.useStores(), projectStore = _j.projectStore, clientStore = _j.clientStore, userStore = _j.userStore, allUserStore = _j.allUserStore;
    var perScreen = userStore.data.settings.ganttChartSettings.maxTaskDisplay;
    var zoom = userStore.data.settings.generalSettings.zoom;
    var showHistoric = userStore.data.settings.ganttChartSettings.showHistoric;
    var navState = use_nav_state_1.useNavState();
    var timerRef = react_1.useRef(null);
    var containerDivRef = react_1.useRef(null);
    var projectsDivRef = react_1.useRef(null);
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    var viewPortHeight = window.innerHeight - (139 * zoom);
    var margin = 16 * zoom;
    var projectHeight = (viewPortHeight / perScreen) - margin;
    var scrollTimerRef = react_1.useRef(null);
    var _k = react_1.useState(null), editIndex = _k[0], setEditIndex = _k[1];
    var _l = react_1.useState(null), highlightProject = _l[0], setHighlightProject = _l[1];
    var highlightTimerRef = react_1.useRef(null);
    var _m = react_1.useState(false), loaded = _m[0], setLoaded = _m[1];
    react_1.useEffect(function () {
        document.title = 'RWD Admin - Gantt Chart';
        navState.saveState(NavState_1.NavState.COLLAPSED);
        scrollTimerRef.current = setTimeout(function () {
            setScrolling(false);
        }, 5000);
        if (projectStore.data.length <= 0 && !utils_1.isBusy(apiRoutes.PROJECTS)) {
            api_1.default.getProjects()
                .then(function (response) {
                projectStore.setData(response.data);
                setLoaded(true);
            })
                .catch(api_1.catchHandler);
        }
        else {
            setLoaded(true);
        }
        if (clientStore.data.length <= 0 && !utils_1.isBusy(apiRoutes.CLIENTS)) {
            api_1.default.getClients()
                .then(function (response) { return clientStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
        if (allUserStore.data.length <= 0 && !utils_1.isBusy(apiRoutes.ALL_USERS)) {
            api_1.default.getAllUsers()
                .then(function (response) { return allUserStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
        return function () {
            clearTimeout(timerRef.current);
            clearTimeout(scrollTimerRef.current);
        };
    }, []);
    react_1.useEffect(function () {
        document.addEventListener('keyup', keyUpHandler);
        return function () {
            document.removeEventListener('keyup', keyUpHandler);
        };
    }, [currentDate]);
    react_1.useEffect(function () {
        window.addEventListener('wheel', wheelHandler);
        document.addEventListener('keyup', keyScrollHandler);
        return function () {
            window.removeEventListener('wheel', wheelHandler);
            document.removeEventListener('keyup', keyScrollHandler);
        };
    }, [scrolledPast]);
    react_1.useEffect(function () {
        if (addOpen || editOpen)
            document.addEventListener('click', fishForExitHandler);
        return function () { return document.removeEventListener('click', fishForExitHandler); };
    }, [addOpen, editOpen]);
    var fishForExitHandler = function (e) {
        var target = e.target;
        if (target.closest('.gantt-chart__new-form'))
            return;
        if (target.closest('.react-datepicker-wrapper'))
            return;
        if (target.classList.contains('add-button'))
            return;
        if (target.classList.contains('select-with-new-entry__form__close'))
            return;
        if (target.classList.contains('react-datepicker__day'))
            return;
        if (target.classList.contains('date-picker__clear'))
            return;
        formCloseHandler();
    };
    var keyScrollHandler = function (e) {
        if (document.body.getAttribute('data-scroll-locked') === 'true')
            return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            var amt = e.key === 'ArrowDown' ? 1 : -1;
            calculateScroll(scrolledPast + amt);
        }
    };
    var wheelHandler = function (e) {
        if (document.body.getAttribute('data-scroll-locked') === 'true')
            return;
        calculateScroll(scrolledPast + (e.deltaY * 0.01));
    };
    var calculateScroll = function (amt) {
        var sortRef = sortProjects();
        var max = sortRef.length - perScreen <= 0 ? 0 : sortRef.length - perScreen;
        amt = utils_1.clamp(0, amt, max);
        clearTimeout(scrollTimerRef.current);
        setScrolling(true);
        setScrolledPast(amt);
        scrollTimerRef.current = setTimeout(function () {
            setScrolling(false);
        }, 2000);
    };
    var scrollStartHandler = function (e) {
        var target = e.target;
        if (target.closest('.gantt-chart-project-task'))
            return;
        setMouseDown({
            x: utils_1.eventCheck(e) ? e.clientX : e.touches[0].clientX,
            y: utils_1.eventCheck(e) ? e.clientY : e.touches[0].clientY
        });
    };
    var scrollEndHandler = function () {
        setMouseDown(null);
    };
    var scrollMoveHandler = function (e) {
        if (!mouseDown)
            return;
        var xPos = utils_1.eventCheck(e) ? e.clientX : e.touches[0].clientX;
        var yPos = utils_1.eventCheck(e) ? e.clientY : e.touches[0].clientY;
        var xDiff = xPos - mouseDown.x;
        var yDiff = yPos - mouseDown.y;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (Math.abs(xDiff) >= 80) {
                var direction = xDiff <= 0 ? Directions.FORWARDS : Directions.BACKWARDS;
                changeCurrentDate(direction);
            }
        }
        else {
            if (Math.abs(yDiff) >= 80) {
                var amt = yDiff <= 0 ? 1 : -1;
                calculateScroll(scrolledPast + amt);
                setMouseDown(null);
            }
        }
    };
    var keyUpHandler = function (e) {
        if (document.body.getAttribute('data-scroll-locked') === 'true')
            return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            var direction = e.key === 'ArrowRight' ? Directions.FORWARDS : Directions.BACKWARDS;
            clearTimeout(timerRef.current);
            changeCurrentDate(direction);
        }
    };
    var changeCurrentDate = function (direction) {
        if (moving)
            return;
        clearTimeout(timerRef.current);
        setMoving(direction);
        timerRef.current = setTimeout(function () {
            setMoving(null);
            setCurrentDate(direction === Directions.FORWARDS ?
                currentDate.add(1, 'w')
                :
                    currentDate.subtract(1, 'w'));
        }, 200);
        setMouseDown(null);
    };
    var toggleOpen = function (position) {
        utils_1.lockScroll();
        setAddOpen(position);
    };
    var projectChangeHandler = function (e) {
        var _a;
        setProjectData(__assign(__assign({}, projectData), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var projectDateChangeHandler = function (name, date) {
        var _a;
        var parsed = date && dayjs_1.default(date).format() || null;
        setProjectData(__assign(__assign({}, projectData), (_a = {}, _a[name] = parsed, _a)));
    };
    var projectSubmitHandler = function () {
        var error = null;
        if (!projectData.projectName || projectData.projectName.length <= 0)
            error = 'Please enter a project name';
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        var newProject = __assign(__assign({}, projectData), { clientId: projectData.client && projectData.client.id, projectTasks: [], startDate: projectData.endDate ? null : utils_1.emptyToNull(projectData.startDate, true), endDate: utils_1.emptyToNull(projectData.endDate, true), createdAt: dayjs_1.default().format(), lastEdited: dayjs_1.default().format(), active: true });
        api_1.default.addProject(newProject)
            .then(function (response) {
            projectStore.addDataItem(response.data);
            formCloseHandler();
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Project has been added'
            });
        })
            .catch(api_1.catchHandler);
    };
    var projectClientChangeHandler = function (client) {
        setProjectData(__assign(__assign({}, projectData), { client: client }));
    };
    var projectClientSubmitHandler = function (value) {
        var newClient = new FormData();
        newClient.append('clientName', value);
        api_1.default.addClient(newClient)
            .then(function (response) {
            clientStore.addDataItem(response.data);
            setProjectData(__assign(__assign({}, projectData), { client: response.data }));
        })
            .catch(api_1.catchHandler);
    };
    var sortProjects = function () {
        var sortFunc = function (a, b) {
            var aEnd = utils_1.getProjectEnd(a);
            var bEnd = utils_1.getProjectEnd(b);
            return aEnd.isBefore(bEnd) ? -1 : aEnd.isAfter(bEnd) ? 1 : 0;
        };
        var sortedProjects = projectStore.data.slice().sort(sortFunc);
        if (!showHistoric) {
            sortedProjects = sortedProjects.filter(function (project) { return project.active; });
        }
        return sortedProjects;
    };
    var setEditIdHandler = function (id) {
        var sortedProjects = sortProjects();
        sortedProjects.forEach(function (project, index) {
            if (project.id === id)
                setEditIndex(index);
        });
    };
    var scrollToHandler = function (id) {
        if (editIndex === null)
            return;
        var sortedProjects = sortProjects();
        clearTimeout(highlightTimerRef.current);
        sortedProjects.forEach(function (project, index) {
            if (project.id === id) {
                if (index !== editIndex) {
                    var range = utils_1.dateRange(currentDate);
                    var projectEnd = utils_1.getProjectEnd(project);
                    if (projectEnd.isBefore(range.start) || projectEnd.isAfter(range.end)) {
                        setCurrentDate(projectEnd.subtract(1, 'w'));
                    }
                    calculateScroll(index - 1);
                    setHighlightProject(project.id);
                    highlightTimerRef.current = setTimeout(function () {
                        setHighlightProject(null);
                    }, 1500);
                }
            }
        });
        setEditIndex(null);
    };
    var setEditProjectHandler = function (project, position) {
        utils_1.lockScroll();
        setEditOpen(position);
        setAddOpen(null);
        setProjectData(project);
        setEditIdHandler(project.id);
    };
    var getFormStyle = function () {
        var _a;
        var position = addOpen !== null ? addOpen : editOpen;
        var hDirection = position.x >= window.innerWidth * 0.75 ? 'right' : 'left';
        var hAmt = hDirection === 'right' ? (window.innerWidth - position.x) : position.x;
        var hInvert = hDirection === 'right' ? -1 : 1;
        var vDirection = position.y >= window.innerHeight * 0.5 ? 'bottom' : 'top';
        var vAmt = position.y >= window.innerHeight * 0.5 ?
            (window.innerHeight - position.y) : position.y;
        var vInvert = vDirection === 'bottom' ? -1 : 1;
        return _a = {},
            _a[hDirection] = '0',
            _a[vDirection] = '0',
            _a.transform = "translate(" + hAmt * hInvert + "px, " + vAmt * vInvert + "px)",
            _a;
    };
    var formCloseHandler = function () {
        setEditOpen(null);
        setAddOpen(null);
        setProjectData({});
        utils_1.unlockScroll();
    };
    var editProjectSubmitHandler = function () {
        if (projectData.projectName.length <= 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: 'Please enter a project name'
            });
            return;
        }
        var newData = utils_1.pinToDeadline(__assign(__assign({}, projectData), { startDate: projectData.endDate ? null : utils_1.emptyToNull(projectData.startDate, true), endDate: utils_1.emptyToNull(projectData.endDate, true), clientId: projectData.client && projectData.client.id }));
        function submitAndSave() {
            api_1.default.editProject(newData)
                .then(function (response) {
                projectStore.editDataItem(response.data);
                formCloseHandler();
                scrollToHandler(projectData.id);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Project has been saved'
                });
            });
        }
        var newEnd = utils_1.getProjectEnd(newData);
        var now = dayjs_1.default().startOf('d');
        if (newEnd.isBefore(now)) {
            dialog({
                variant: Dialog_1.DialogVariants.CONFIRMATION,
                title: 'This will mark the project as historic in 2 weeks time',
                description: 'The deadline or start date you have entered puts this project\'s end date before today\'s date, this will mark the project as being historic after 2 weeks have passed. Are you sure you want to continue?'
            })
                .then(function () {
                submitAndSave();
            });
            return;
        }
        submitAndSave();
    };
    var deleteProjectHandler = function (project) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Delete " + project.projectName + "?",
            description: 'Are you sure you want to delete this project?'
        })
            .then(function () {
            api_1.default.deleteProject(project)
                .then(function () {
                projectStore.removeDataItem(project);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Project has been deleted'
                });
            })
                .catch(api_1.catchHandler);
        });
    };
    var sortedProjects = sortProjects();
    var scrollAmt = scrolledPast * (projectHeight + margin);
    var displayItemMax = utils_1.clamp(1, scrolledPast + perScreen, sortedProjects.length);
    // TODO Jump to Date feature?
    return (react_1.default.createElement("div", { className: 'gantt-chart' },
        react_1.default.createElement("div", { className: 'gantt-chart-rail flex flex-column', "data-moving": moving },
            react_1.default.createElement(GanttChartHeader_1.default, { currentDate: currentDate }),
            react_1.default.createElement(GanttChartGrid_1.default, { currentDate: currentDate, grabbing: mouseDown !== null }),
            react_1.default.createElement("div", { ref: containerDivRef, className: 'gantt-chart__projects-container' },
                react_1.default.createElement("div", { className: 'gantt-chart__projects flex flex-column', onTouchStartCapture: scrollStartHandler, onMouseDown: scrollStartHandler, onMouseUp: scrollEndHandler, onTouchEndCapture: scrollEndHandler, onMouseMove: scrollMoveHandler, onTouchMoveCapture: scrollMoveHandler, "data-loaded": loaded, ref: projectsDivRef, style: {
                        transform: "translate(0, -" + scrollAmt + "px)"
                    }, "data-grabbing": mouseDown !== null }, sortedProjects.map(function (project, i) { return i >= scrolledPast && i < (displayItemMax) ? (react_1.default.createElement(GanttChartProject_1.default, { highlight: highlightProject === project.id, height: projectHeight, currentDate: currentDate, project: project, scrollAmt: scrollAmt, key: "gcp_" + project.id, onSetEdit: setEditProjectHandler, setEditId: setEditIdHandler, scrollTo: scrollToHandler })) :
                    react_1.default.createElement("div", { className: 'gantt-chart__empty-row', style: { height: projectHeight + "px" }, key: "gcp_" + project.id + "_empty_" + i }, "\u00A0"); })))),
        react_1.default.createElement("div", { className: 'gantt-chart__position flex flex-row flex-center', "data-visible": scrolling },
            react_1.default.createElement("span", null, "Showing"),
            react_1.default.createElement("span", null,
                utils_1.clamp(1, scrolledPast + 1, sortedProjects.length),
                "-",
                displayItemMax),
            react_1.default.createElement("span", null, "Of"),
            react_1.default.createElement("span", null, sortedProjects.length)),
        react_1.default.createElement("button", { type: 'button', "aria-label": 'New Project', title: 'New Project', onClick: function (e) { return toggleOpen({ x: e.clientX, y: e.clientY }); }, className: 'gantt-chart__new-project' },
            react_1.default.createElement("img", { src: add_icon_dark_svg_1.default, alt: 'New Project' })),
        (addOpen || editOpen) &&
            react_1.default.createElement(GanttChartProjectForm_1.default, { projectData: projectData, style: getFormStyle(), formType: addOpen !== null ? FormTypes.ADD_FORM : FormTypes.EDIT_FORM, clients: clientStore.data, onClose: formCloseHandler, onChange: projectChangeHandler, onSubmit: addOpen !== null ? projectSubmitHandler : editProjectSubmitHandler, onChangeDate: projectDateChangeHandler, onChangeClient: projectClientChangeHandler, onSubmitClient: projectClientSubmitHandler, onDeleteProject: deleteProjectHandler })));
});
exports.default = GanttChart;
